import {useContext} from 'react';

import {AppContextContext, AppContextValue} from './app-context-provider';

export const useAppContext = () => {
    return useContext<AppContextValue>(AppContextContext);
};
